// extracted by mini-css-extract-plugin
module.exports = {"label":"CompanyNameWebsiteInputs_label___YvgV","inputs-container":"CompanyNameWebsiteInputs_inputs-container__PlleD"};